import React, { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import FallbackCards from '../../modules/helpers/FallbackCards'
import PrincipalContactoResumen from '../../modules/homeout/principal/components/PrincipalContactoResumen'

const HomeOutCuidados = React.lazy(() => import('../../modules/homeout/cuidados/screens/HomeOutCuidados'))
const PageNotFound = React.lazy(() => import('../../modules/404/PageNotFound'))

const RouterOutCuidados = () => {
    return (
        <>
            <Suspense fallback={<FallbackCards />}>
                <Routes>
                    <Route path='/' element={<HomeOutCuidados />} />
                    <Route path='/404' element={<PageNotFound />} />
                    <Route path='*' element={<Navigate to="/404" />} />
                </Routes>

                {window.location.pathname !== "/cuidados" && < PrincipalContactoResumen />}
            </Suspense>
        </>
    )
}

export default RouterOutCuidados